export enum TemplateType {
  Free = 'free',
  Premium = 'premium',
  Business = 'business',
}

export interface TemplateHit {
  objectID: string;
  template_id: string;
  title: string;
  type: TemplateType;
  isMultipage: 0 | 1;
  width: number;
  height: number;
  e2TemplateEnabled: boolean;
  categories: string[];

  // Not used but are included in the algolia records
  size: string;
  subcategories: string[];
  chart_type: string[];
  theme: string[];
  header: string;
  subheader: string[];
  styles: string[];
  difficulty_label: string;
  roles: string[];
  goals: string[];
  content_type: string[];
  complexity: string[];
}

export interface SearchApiResponse {
  hits: TemplateHit[];
  nbPages: number;
  page: number;
  hitsPerPage: number;
  nbHits: number;
  exhaustiveTypo: number;
  exhaustiveNbHits: number;
  params: string;
  processingTimeMS: number;
  query: string;
}

export interface PaginatedTemplateSearch {
  error: string;
  hasMore: boolean;
  isLoadingMore: boolean;
  isLoadingInitialData: boolean;
  hasNoResultsFound: boolean;
  query: string;
  templates: TemplateHit[];
  onShowMore: () => void;
  clearSearch: () => void;
  searchTemplates: (query: string) => void;

  // Applying filters to search
  filters: TemplateFilters;
  setFilters: (filters: TemplateFilters) => void;
}

export enum PageSize {
  Letter = 'letter',
  Custom = 'custom',
  Square = 'square',
}

export enum Layout {
  Portrait = 'portrait',
  Landscape = 'landscape',
}

/**
 * Filters that can be applied to template search
 */
export type TemplateFilters = {
  // Specify in algolia search request
  planType?: TemplateType[];
  isAccessible?: boolean;

  // Parsed separately after search
  pageSize?: PageSize[];
  layout?: Layout[];
};

export type PaginatedTemplatesSearchOptions = {
  // If true, will fetch all data based on filters only, will ignore query
  fetchAllByFilter?: boolean;
  filters?: TemplateFilters;
};
